<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6962 15.0971V11.9807C17.6962 7.73099 14.2504 4.28516 10.0006 4.28516C5.74962 4.28516 2.30505 7.73099 2.30505 11.9807V15.0971"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.0455 10.4551H5.95436C4.29187 10.4551 2.94482 11.8021 2.94482 13.4646V14.6005C2.94482 16.263 4.29187 17.6101 5.95436 17.6101H7.44133C7.91832 17.6101 8.34317 17.3124 8.50726 16.8634C8.67007 16.4156 9.09619 16.1167 9.57319 16.1167H10.1558C10.6328 16.1167 11.0576 16.4144 11.2217 16.8634C11.3845 17.3111 11.8106 17.6101 12.2876 17.6101H14.0468C15.7093 17.6101 17.0563 16.263 17.0563 14.6005V13.4646C17.0563 11.8021 15.7093 10.4551 14.0468 10.4551H14.0455Z"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.3134 11.7266H16.5018C16.8504 12.2176 17.0551 12.8179 17.0551 13.4654V14.6013C17.0551 15.2347 16.8593 15.8211 16.5247 16.3057H17.3134C17.999 16.3057 18.5548 15.7499 18.5548 15.0643V12.968C18.5548 12.2824 17.999 11.7266 17.3134 11.7266Z"
      fill="var(--primary-blue)"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M2.94487 14.5993V13.4634C2.94487 12.816 3.15094 12.2156 3.49819 11.7246H2.68666C2.00105 11.7246 1.44519 12.2805 1.44519 12.9661V15.0623C1.44519 15.7479 2.00105 16.3038 2.68666 16.3038H3.47529C3.14203 15.8192 2.94487 15.2315 2.94487 14.5993Z"
      fill="var(--primary-blue)"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script>
  export default {
    name: 'StationLogo',
  }
</script>

<style scoped>
  /* Add custom styles if needed */
</style>
